import * as React from 'react';
import styles from './Pill.module.css';
const Pill = ({ index, active, onClick }) => {
    return (React.createElement("div", { onClick: onClick, className: styles.pillWrapper },
        React.createElement("div", { "data-pill": active ? 'active' : '' })));
};
export default Pill;
//# sourceMappingURL=Pill.js.map